import 'arrive';
import $ from 'jquery';

document.arrive('.authors-archive', { existing: true }, function () {

    var $authorsArchive = $(this);
    var $fixedBar = $('.authors-archive__fixed-authors-filters');
    var $footer = $('footer');
    var $letterSections = $('.letter-section');
    var $navigationLinks = $('.letters-navigation a');
    var offset = getScrollOffset();

    function getScrollOffset() {
        return window.innerWidth < 768 ? 100 : 200;
    }



    function scrollActiveLetterIntoView() {
        if (window.innerWidth >= 768) return; // Solo mobile

        var $container = $('.letters-navigation');
        var $activeLink = $container.find('a.active');
        if (!$container.length || !$activeLink.length) return;

        var containerOffset = $container.offset().left;
        var containerScroll = $container.scrollLeft();
        var containerWidth = $container.outerWidth();

        var linkOffset = $activeLink.offset().left;
        var linkWidth = $activeLink.outerWidth();

        // Calcola posizione del link rispetto al contenitore
        var relativeLeft = linkOffset - containerOffset + containerScroll;

        // Scroll target: centra l’active link
        var scrollTo = relativeLeft - (containerWidth / 2) + (linkWidth / 2);

        $container.stop().animate({ scrollLeft: scrollTo }, 300);
    }


    function updateActiveNavigation() {
        var windowTop = $(window).scrollTop();
        var currentSection = null;

        // Trova la sezione attualmente visibile
        $letterSections.each(function() {
            var $section = $(this);
            var sectionTop = $section.offset().top - offset; // offset di 200px
            var sectionBottom = sectionTop + $section.outerHeight();

            if (windowTop >= sectionTop && windowTop < sectionBottom) {
                currentSection = $section.attr('id');
                return false; // break del loop
            }
        });

        // Se nessuna sezione è trovata, usa la prima se siamo sopra tutto
        if (!currentSection && windowTop < $letterSections.first().offset().top - offset) {
            currentSection = $letterSections.first().attr('id');
        }

        // Aggiorna le classi active
        if (currentSection) {
            $navigationLinks.removeClass('active');
            $navigationLinks.filter('[href="#' + currentSection + '"]').addClass('active');
            scrollActiveLetterIntoView();
        }
    }

    function updateFixedBarPosition() {
        if (!$fixedBar.length || !$footer.length) {
            return;
        }

        var windowTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var windowBottom = windowTop + windowHeight;
        var footerTop = $footer.offset().top;

        // Se il footer è visibile nella viewport
        if (windowBottom >= footerTop) {
            // Cambia a position absolute
            $fixedBar.css({
                'position': 'absolute',
                'bottom': '0'
            });
        } else {
            // Mantieni position fixed
            $fixedBar.css({
                'position': 'fixed',
                'bottom': '0'
            });
        }
    }

    // Mostra sempre la fixed bar
    $fixedBar.addClass('show');

    // Esegui all'avvio
    updateActiveNavigation();
    updateFixedBarPosition();

    // Esegui allo scroll con throttling per performance
    var scrollTimeout;
    $(window).on('scroll', function() {
        if (scrollTimeout) {
            clearTimeout(scrollTimeout);
        }
        scrollTimeout = setTimeout(function() {
            updateActiveNavigation();
            updateFixedBarPosition();
        }, 10);
    });

    // Smooth scroll per i link delle lettere + attiva classe active al click
    $('.letters-navigation a').on('click', function(e) {
        e.preventDefault();
        var $clickedLink = $(this);
        var target = $clickedLink.attr('href');
        var $targetSection = $(target);

        // 🔹 Rimuovi highlight da eventuale autore selezionato
        $('.author-item').removeClass('highlight');

        // 🔹 Ripulisci anche il parametro highlight dall'URL
        var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + target;
        history.replaceState(null, null, newUrl);

        // 🔹 Rimuovi active da tutti e aggiungilo al link cliccato
        $navigationLinks.removeClass('active');
        $clickedLink.addClass('active');
        scrollActiveLetterIntoView();

        // 🔹 Gestione highlight sulla lettera
        $('.letter-title').removeClass('highlight');
        $targetSection.find('.letter-title').addClass('highlight');

        // Scroll fluido con offset
        if ($targetSection.length) {
            $('html, body').animate({
                scrollTop: $targetSection.offset().top - offset
            }, 500);
        }
    });

});